import { palette } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const styles: moduleStyleType = {
    icon: {
        fontSize: 16,
        display: 'block',
        marginLeft: 0,
    },
    unspecified: {
        color: palette.error.main,
    },
    open: {
        color: palette.warning.main,
    },
    purple: {
        color: palette.primary.light,
    },
}
